import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';

angular.module('cloudX').directive('cxEnum', [
  'enumCacheSvc',
  '$filter',
  '$rootScope',
  '$timeout',
  '$q',
  function(enumCacheSvc, $filter, $rootScope, $timeout, $q) {
    return {
      restrict: 'E',
      require: '^ngModel',
      template:
        '<select ng-model="value" id="{{::(ctrlId || eName || type)}}DropDown" name="{{::(eName || type)}}" ng-options="item.key as (item.label || item.value) for item in items" ng-change="setValue()" ng-required="!allowNull" class="form-control" ng-class="eClass" ng-disabled="ngDisabled">' +
        '<option value="" ng-show="(!value && value!==0) || allowNull">{{placeholder}}</option>' +
        '</select>',
      scope: {
        type: '@',
        allowNull: '=?',
        eClass: '=?',
        eName: '@?',
        ctrlId: '@?',
        ngDisabled: '=?',
        orderByLabel: '@?',
        nullLabel: '@?',
        onChange: '&',
      },
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        scope.items = [];

        enumCacheSvc.get(scope.type).then(function(data) {
          scope.items = data;
          translateLabels();
        });

        function translateLabels() {
          scope.placeholder =
            scope.nullLabel ||
            $filter('translateList')(null, scope.type) ||
            '- ' + $filter('translate')('Choose') + ' -';
          scope.items.forEach(function(item) {
            if (
              (scope.type === 'emailReplyToType' || scope.type === 'emailSenderNameType') &&
              item.key > 2 &&
              item.key < 9
            ) {
              // If the Type is one of the employee profiles, we need to translate it using the employee profile enum, which has the same order but is 2 lower
              item.label = $filter('translateList')(item.key - 2, 'employeeprofile', item.value);
            } else {
              item.label = $filter('translateList')(item.key, scope.type, item.value);
            }
          });
          scope.items.sort(dynamicSort(scope.orderByLabel ? 'label' : 'key'));
        }
        var deregistration = $rootScope.$on('$translateChangeSuccess', translateLabels);
        scope.$on('$destroy', deregistration);

        ngModel.$render = function() {
          scope.value = ngModel.$viewValue;
        };
        scope.setValue = function() {
          ngModel.$setViewValue(scope.value);
          if (scope.onChange) {
            $timeout(function() {
              $q.when(scope.onChange());
            });
          }
        };
      },
    };
  },
]);
